import { render, staticRenderFns } from "./relation-add.vue?vue&type=template&id=756a59c9&scoped=true&"
import script from "./relation-add.vue?vue&type=script&lang=js&"
export * from "./relation-add.vue?vue&type=script&lang=js&"
import style0 from "./relation-add.vue?vue&type=style&index=0&id=756a59c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756a59c9",
  null
  
)

export default component.exports